<!-- Initial State: Yes / No / Skip -->
<div *ngIf="currentState === 'initial'">
  <h2 mat-dialog-title>Hospital Group Email</h2>
  <mat-dialog-content>
    <p>
      Great news! You now have the option to cc your clinic's email address to receive a copy of your
      case submission confirmations and consultation final reports. Would you like to add an email address?
    </p>
    <p *ngIf="data?.practiceName || data?.hospitalCode" class="clinic-name">
      Clinic name: <strong>{{ data.practiceName }}</strong><span *ngIf="data?.hospitalCode">, ({{ data.hospitalCode }})</span>
    </p>
    <p class="dialog-note">
      You will always have the option to edit, add, or remove the email address later by visiting your profile.
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button color="primary" (click)="onSkip()">Skip For Now</button>
    <button mat-button color="warn" (click)="onNo()">No, Thank You</button>
    <button mat-raised-button color="primary" (click)="onYes()">Yes</button>
  </mat-dialog-actions>
</div>

<!-- Email Input State -->
<div *ngIf="currentState === 'emailInput'">
  <h2 mat-dialog-title>Enter Hospital Email Address</h2>
  <mat-dialog-content>
    <p>Please enter your hospital's official company email address.</p>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Hospital Email</mat-label>
      <input matInput type="email" [formControl]="emailControl" placeholder="email@yourcompany.com">
      <mat-error *ngIf="emailControl.hasError('required')">Email is required</mat-error>
      <mat-error *ngIf="emailControl.hasError('email') && !emailControl.hasError('required')">
        Please input a valid email address
      </mat-error>
    </mat-form-field>
    <div *ngIf="domainError" class="domain-error">
      {{ domainError }}
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onBackToInitial()">Back</button>
    <button mat-raised-button color="primary" (click)="onSubmitEmail()">Submit</button>
  </mat-dialog-actions>
</div>

<!-- Confirmation State -->
<div *ngIf="currentState === 'confirm'">
  <h2 mat-dialog-title>Confirm Email Address</h2>
  <mat-dialog-content>
    <p *ngIf="data?.practiceName || data?.hospitalCode" class="clinic-name">
      Clinic name: <strong>{{ data.practiceName }}</strong><span *ngIf="data?.hospitalCode">, ({{ data.hospitalCode }})</span>
    </p>
    <p>You entered the following email address:</p>
    <p class="confirm-email"><strong>{{ enteredEmail }}</strong></p>
    <p>Is this correct?</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onConfirmEdit()">No, Edit My Email Address</button>
    <button mat-raised-button color="primary" (click)="onConfirmYes()">Yes, This Is Correct</button>
  </mat-dialog-actions>
</div>
